import {Component, OnInit} from '@angular/core';
import {
  Photo,
  PhotoGallerySettings
} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {
  Animal,
  Rarity,
  Entry,
  Entries
} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {TarangireText} from "./tarangire.text";
import {Park, Point} from "../../../../google-maps-points";

@Component({
  selector: 'app-tarangire',
  templateUrl: './tarangire.component.html',
  styleUrls: ['./tarangire.component.css']
})
export class TarangireComponent implements OnInit {

  tripEntries: TripEntry[] = [
    new TripEntry({title: 'Big Buck', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
    new TripEntry({title: 'Culture Quest', route: '../../safari/culture-quest-safari', iconName: 'drum'})
  ];

  parkText = new TarangireText();

  // Animal Rarity Tooltips
  animalEntries: Entries = new Entries({
    entries:
      [
        new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
        new Entry({animal: Animal.YellowBarbet, rarity: Rarity.Common}),
        new Entry({animal: Animal.Giraffe, rarity: Rarity.Common}),
        new Entry({animal: Animal.SouthernGroundHornbill, rarity: Rarity.Common}),
        new Entry({animal: Animal.Warthog, rarity: Rarity.Common}),
        new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
        new Entry({animal: Animal.Jackal, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.Lion, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.DwarfMongoose, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.SpottedHyena, rarity: Rarity.Uncommon})
      ]
  });

  // photo gallery metadata
  vervetPhotoGallery: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Sneaky Vervet Monkey',
          description: 'Watch your lunch carefully! This sneaky vervet monkey was hungering for a banana!',
          thumbnailPath: '700x525/vervet-monkey.jpg',
          highresPath: '../../assets/img/others/vervet-monkey.jpg',
          altPhotoDescription: 'Vervet Monkey steals a banana!'
        })
      ]
  });

  tarangirePhotoGallery: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Elephant Block Party!',
          description: 'A herd of elephants graze along the Tarangire River.',
          thumbnailPath: '700x525/tarangire-river.jpg',
          highresPath: '../../assets/img/others/tarangire-river.jpg',
          altPhotoDescription: 'Large Elephant Herd drink at the Tarangire River.'
        })
      ]
  });

  baobabPhotoGallery: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Tree of Life',
          description: 'Baobab Trees can live to be more than 1,000 years old.',
          thumbnailPath: '700x525/baobab-tree.jpg',
          highresPath: '../../assets/img/others/baobab-tree.jpg',
          altPhotoDescription: 'Large Baobab Tree standing tall against the Tarangire Landscape.'
        })
      ]
  });

  mapLat = -3.71626363;
  mapLng = 35.98056793;

  circleWidthsDesktop = ['5.5rem', '4rem', '5.5rem', '4.5rem'];
  circleWidthsMobile = ['6.5rem', '4.5rem', '6.25rem', '5.25rem'];

  parkBoundaries = [
    new Park({
      name: 'Tarangire National Park',
      contentId: '/national-parks/tarangire',
      defaultColor: '#2D1582',
      hoverColor: '#1D0E53',
      tooltipOrigin: new Point({lng: 35.98056793, lat: -3.71626363}),
      points:
        [
          new Point({lng: 35.98485947, lat: -3.70375862}),
          new Point({lng: 35.9793663, lat: -3.71746274}),
          new Point({lng: 35.97121239, lat: -3.71977529}),
          new Point({lng: 35.96863747, lat: -3.73827546}),
          new Point({lng: 35.96271515, lat: -3.74855317}),
          new Point({lng: 35.96220016, lat: -3.7823831}),
          new Point({lng: 35.96220016, lat: -3.7823831}),
          new Point({lng: 35.95928192, lat: -3.79060486}),
          new Point({lng: 35.95464706, lat: -3.79745627}),
          new Point({lng: 35.91473579, lat: -3.84404438}),
          new Point({lng: 35.92417717, lat: -3.8479837}),
          new Point({lng: 35.9276104, lat: -3.85243683}),
          new Point({lng: 35.93104362, lat: -3.85757502}),
          new Point({lng: 35.93147278, lat: -3.86562478}),
          new Point({lng: 35.93009949, lat: -3.87915507}),
          new Point({lng: 35.92108727, lat: -3.90124837}),
          new Point({lng: 35.90752602, lat: -3.92214226}),
          new Point({lng: 35.8733654, lat: -3.9450907}),
          new Point({lng: 35.86993217, lat: -3.94937205}),
          new Point({lng: 35.86392403, lat: -3.94731701}),
          new Point({lng: 35.86169243, lat: -3.95039958}),
          new Point({lng: 35.86375237, lat: -3.95519466}),
          new Point({lng: 35.85216522, lat: -4.06633003}),
          new Point({lng: 35.91516495, lat: -4.13986961}),
          new Point({lng: 35.95464706, lat: -4.20347285}),
          new Point({lng: 35.95808029, lat: -4.20432885}),
          new Point({lng: 35.9611702, lat: -4.20621204}),
          new Point({lng: 35.96151352, lat: -4.20980721}),
          new Point({lng: 35.96031189, lat: -4.21340237}),
          new Point({lng: 35.99833488, lat: -4.27357592}),
          new Point({lng: 36.00245476, lat: -4.2838469}),
          new Point({lng: 36.00769043, lat: -4.30481638}),
          new Point({lng: 36.04167938, lat: -4.41829826}),
          new Point({lng: 36.07995987, lat: -4.57077815}),
          new Point({lng: 36.25110626, lat: -4.56769806}),
          new Point({lng: 36.27754211, lat: -4.52389099}),
          new Point({lng: 36.2878418, lat: -4.49856382}),
          new Point({lng: 36.29676819, lat: -4.49034941}),
          new Point({lng: 36.30037308, lat: -4.18806473}),
          new Point({lng: 36.14707947, lat: -3.87059162})
        ]
    })
  ]

  constructor() {
  }

  ngOnInit() {
  }

  isMobile() {
    return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
  }

  isMobileBr() {
    return document.body.clientWidth < 500;
  }

}
